import React, { useState } from "react";
import { Link } from "react-router-dom";

const NavBar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  // State to track open/closed state of each submenu
  const [openSubMenus, setOpenSubMenus] = useState({});

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Function to toggle submenu visibility
  const toggleSubMenu = (menuId) => {
    setOpenSubMenus((prev) => ({
      ...prev,
      [menuId]: !prev[menuId], // Toggle the specific submenu's state
    }));
  };

  // Menu items data to avoid repetition and make it easier to manage
  const menuItems = [
    {
      id: "home",
      title: "Home",
      link: "/",
    },
    {
      id: "it-services",
      title: "IT Services",
      subMenu: [
        { title: "IT Services", link: "/services" },
        // { title: "Projects", link: "/projects" },
      ],
    },
    {
      id: "kids",
      title: "Kids",
      subMenu: [
        { title: "Kids Training", link: "/kids" },
        { title: "Quizzes", link: "/quize" },
      ],
    },
    {
      id: "corporate-training",
      title: "Corporate Training",
      subMenu: [
        { title: "IT Training", link: "/programs" },
        { title: "Campus To Corporate", link: "/campus-to-corporate" },
      ],
    },
    {
      id: "robotic-labs",
      title: "Robotic Labs",
      subMenu: [
        { title: "Robotic Kits", link: "/robotic-lab" },
        { title: "Robotic Syllabus", link: "/robotic-syllabus" },
      ],
    },
    {
      id: "ojt",
      title: "OJT",
      link: "/ojt",
    },
    {
      id: "more",
      title: "More",
      subMenu: [
        { title: "Blogs", link: "/blogs" },
        { title: "Case Study", link: "/case-study" },

        { title: "Contactus", link: "/contactus" },
        { title: "College Registration", link: "/college-register" },

        { title: "Mentor Registration", link: "/mentor-register" },
        // { title: "Hire Us", link: "/hire-us" },





      ],
    },
  ];

  return (
    <>
      <header>
        <link
          href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap-icons/1.8.1/font/bootstrap-icons.min.css"
          rel="stylesheet"
        />
        <div className="tg-header__top">
          <div className="toasts" id="toasts"></div>
          <div className="container custom-container">
            <div className="row">
              <div className="col-lg-6">
                <ul className="tg-header__top-info list-wrap">
                  <li>
                    <img src="/assets/img/icons/envelope.svg" alt="Icon" />{" "}
                    <a href="mailto:info@skillgrodemo.com">
                      support@sysinsightsolutions.com
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-lg-6">
                <div className="tg-header__top-right">
                  <div className="tg-header__phone">
                    <img src="/assets/img/icons/phone.svg" alt="Icon" />
                    Call us: <a href="tel:0123456789">+91 9834143101/ +91 9860491861</a>
                  </div>
                  <ul className="tg-header__top-social list-wrap">
                    <li>Follow Us On :</li>
                    <li>
                      <a href="https://www.facebook.com/sysinsightsolutions">
                        <i className="fab fa-facebook-f" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.instagram.com/sysinsightsolutions/">
                        <i className="fab fa-instagram" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.linkedin.com/company/107048112/admin/dashboard/">
                        <i className="fab fa-linkedin-in" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="header-fixed-height" />
        <div id="sticky-header" className="tg-header__area">
          <div className="container custom-container">
            <div className="row">
              <div className="col-12">
                <div className="tgmenu__wrap">
                  <nav className="tgmenu__nav">
                    <div className="logo">
                      <Link to="/">
                        <img
                          src="/images/sys-new-logo2.png"
                          alt="Logo"
                          height={65}
                        />
                      </Link>
                    </div>
                    <div
                      className="logo"
                      style={{
                        borderLeft: "2px solid gainsboro",
                        paddingLeft: "1vh",
                      }}
                    ></div>
                    <div className="tgmenu__navbar-wrap tgmenu__main-menu d-none d-xl-flex">
                      <ul className="navigation">
                        {menuItems.map((item) => (
                          <li
                            key={item.id}
                            className={`ms-4 ${item.subMenu ? "menu-item-has-children" : ""}`}
                          >
                            {item.subMenu ? (
                              <>
                                <a href="#">{item.title}</a>
                                <ul className="sub-menu">
                                  {item.subMenu.map((subItem, index) => (
                                    <li key={index}>
                                      <Link to={subItem.link}>{subItem.title}</Link>
                                    </li>
                                  ))}
                                </ul>
                              </>
                            ) : (
                              <Link to={item.link}>{item.title}</Link>
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="tgmenu__action">
                      <ul className="list-wrap">
                        <li className="header-btn login-btn">
                          <Link
                            to="/login"
                            className="btn arrow-btn new-btn text-white rounded"
                          >
                            Log in
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <div className="mobile-login-btn">
                      <a href="/login">
                        <img
                          src="/assets/img/icons/user.svg"
                          alt=""
                          className="injectable"
                        />
                      </a>
                    </div>
                    <div className="mobile-nav-toggler" onClick={toggleMobileMenu}>
                      <i className="tg-flaticon-menu-1" />
                    </div>
                  </nav>
                </div>
                {/* Mobile Menu */}
                <div className={`tgmobile__menu ${isMobileMenuOpen ? "open" : ""}`}>
                  <nav className="tgmobile__menu-box">
                    <div className="close-btn" onClick={toggleMobileMenu}>
                      <i className="tg-flaticon-close-1" />
                    </div>
                    <div className="nav-logo">
                      <Link to="/">
                        <img
                          src="/images/sys-new-logo2.png"
                          alt="Logo"
                          height={65}
                        />
                      </Link>
                    </div>
                    <div className="tgmobile__search">
                      <form action="#">
                        <input type="text" placeholder="Search here..." />
                        <button>
                          <i className="fas fa-search" />
                        </button>
                      </form>
                    </div>
                    <ul className="navigation">
                      {menuItems.map((item) => (
                        <li
                          key={item.id}
                          className={`ms-4 ${item.subMenu ? "menu-item-has-children" : ""}`}
                        >
                          {item.subMenu ? (
                            <>
                              <a href="#">{item.title}</a>
                              <ul
                                className="sub-menu"
                                style={{
                                  display: openSubMenus[item.id] ? "block" : "none",
                                }}
                              >
                                {item.subMenu.map((subItem, index) => (
                                  <li key={index}>
                                    <Link to={subItem.link}>{subItem.title}</Link>
                                  </li>
                                ))}
                              </ul>
                              <div
                                className="dropdown-btn"
                                onClick={() => toggleSubMenu(item.id)}
                              >
                                <span className="plus-line"></span>
                              </div>
                            </>
                          ) : (
                            <Link to={item.link}>{item.title}</Link>
                          )}
                        </li>
                      ))}
                    </ul>
                    <div className="social-links">
                      <ul className="list-wrap">
                        <li>
                          <a href="https://www.facebook.com/sysinsightsolutions">
                            <i className="fab fa-facebook-f" />
                          </a>
                        </li>
                        
                        <li>
                          <a href="https://www.instagram.com/sysinsightsolution/?__pwa=1">
                            <i className="fab fa-instagram" />
                          </a>
                        </li>
                        <li>
                          <a href="https://www.linkedin.com/company/107048112/admin/dashboard/">
                            <i className="fab fa-linkedin-in" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </nav>
                </div>
                <div
                  className={`tgmobile__menu-backdrop ${isMobileMenuOpen ? "open" : ""}`}
                  onClick={toggleMobileMenu}
                />
                {/* End Mobile Menu */}
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default NavBar;